module.exports = __webpack_public_path__ + "img/nl.e336d50a.svg";